/*
 * Mijntuinklompen.nl, 16 okt 2026 (besluit 52A)
 * "Voeg toe"-knoppen in de voortgangsbalk naar gratis verzending (snippets/free-shipping-notice.liquid).
 * Eén gedelegeerde listener op document, zodat opnieuw gerenderde winkelwagen-HTML gewoon werkt.
 * Na het toevoegen ververst de winkelwagen via de bestaande theme-componenten (cart-drawer / cart-items),
 * die ook de balk zelf opnieuw ophalen.
 */
(function () {
  if (window.mtkGratisVerzending) return;
  window.mtkGratisVerzending = true;

  function refreshCart() {
    var drawer = document.querySelector('cart-drawer');
    var drawerItems = drawer ? drawer.querySelector('cart-items') : null;
    var pageItems = document.querySelector('cart-items:not(cart-drawer cart-items)');
    if (pageItems && typeof pageItems.refresh === 'function') {
      pageItems.refresh();
    }
    if (drawer && typeof drawer.refresh === 'function') {
      // Met cart-items in de drawer ververst die de balk, de regels en het totaal; anders de hele drawer
      if (drawerItems && typeof drawerItems.refresh === 'function') {
        drawerItems.refresh();
      } else {
        drawer.refresh(true);
      }
    }
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-mtk-gv-add]') : null;
    if (!btn) return;
    evt.preventDefault();

    var id = btn.dataset.variantId;
    var tip = btn.closest('.mtk-gv__tip');
    var select = tip ? tip.querySelector('[data-mtk-gv-select]') : null;
    if (!id && select) {
      id = select.value;
      if (!id) {
        select.classList.add('is-fout');
        select.focus();
        return;
      }
    }
    if (!id || btn.getAttribute('aria-busy') === 'true') return;

    btn.setAttribute('aria-busy', 'true');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: Number(id) } }));
        refreshCart();
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        console.warn('Toevoegen mislukt', err); // eslint-disable-line no-console
      });
  });

  document.addEventListener('change', function (evt) {
    if (evt.target.matches && evt.target.matches('[data-mtk-gv-select]')) {
      evt.target.classList.remove('is-fout');
    }
  });
})();
